import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { MessageCircle, Phone, Clock, AlertTriangle, CheckCircle } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || "";

export const NotificationsLog = () => {
  const [notifications, setNotifications] = useState([]);
  const [whatsappEnabled, setWhatsappEnabled] = useState(false);

  const fetchNotifications = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/notifications`, { withCredentials: true });
      setNotifications(data);
    } catch (error) {
      console.error('Error:', error);
    }
  }, []);

  const fetchStatus = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/integrations/status`, { withCredentials: true });
      const wa = data.integrations?.find(i => i.service === 'whatsapp');
      setWhatsappEnabled(wa?.enabled || false);
    } catch (error) { console.error(error); }
  }, []);

  useEffect(() => { fetchNotifications(); fetchStatus(); }, [fetchNotifications, fetchStatus]);

  return (
    <div className="space-y-6" data-testid="notifications-log">
      <div>
        <h2 className="text-3xl font-medium text-[#0F1B3D]" style={{ fontFamily: 'Outfit, sans-serif' }}>
          Notificações WhatsApp
        </h2>
        <p className="text-[#5F6B85]">Histórico de mensagens enviadas</p>
      </div>

      {whatsappEnabled ? (
        <Card className="border-[#0F1B3D] bg-[#0F1B3D]/5">
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <CheckCircle className="h-5 w-5 text-[#0F1B3D]" />
              <div>
                <p className="text-sm font-medium text-[#0F1B3D]">WhatsApp Conectado</p>
                <p className="text-xs text-[#5F6B85]">Notificações sendo enviadas via Twilio.</p>
              </div>
            </div>
          </CardContent>
        </Card>
      ) : (
        <Card className="border-[#E9C46A] bg-[#E9C46A]/5">
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <AlertTriangle className="h-5 w-5 text-[#E9C46A]" />
              <div>
                <p className="text-sm font-medium text-[#0F1B3D]">WhatsApp Simulado</p>
                <p className="text-xs text-[#5F6B85]">
                  As notificações estão sendo registradas localmente. Configure o Twilio em Configurações para enviar via WhatsApp real.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      )}

      <div className="space-y-4">
        {notifications.length === 0 ? (
          <Card className="border-[#E5DCC8]">
            <CardContent className="p-8 text-center">
              <MessageCircle className="h-12 w-12 text-[#7A85A0] mx-auto mb-3" />
              <p className="text-[#7A85A0]">Nenhuma notificação enviada ainda</p>
              <p className="text-sm text-[#7A85A0] mt-1">
                Vá em Consultas e clique no ícone de WhatsApp para enviar uma notificação
              </p>
            </CardContent>
          </Card>
        ) : (
          notifications.map((notif) => (
            <Card key={notif.notification_id} className="border-[#E5DCC8]" data-testid={`notif-${notif.notification_id}`}>
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <div className="p-2 bg-[#0F1B3D]/10 rounded-lg mt-1">
                    <MessageCircle className="h-5 w-5 text-[#0F1B3D]" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-2">
                      <h3 className="font-semibold text-[#0F1B3D]">{notif.patient_name}</h3>
                      <span className="px-2 py-0.5 rounded-full text-xs bg-[#0F1B3D]/10 text-[#0F1B3D] font-medium">
                        {notif.status === 'sent_mock' ? 'Enviado (Mock)' : notif.status}
                      </span>
                    </div>
                    <p className="text-sm text-[#5F6B85] mb-2">{notif.message}</p>
                    <div className="flex items-center gap-4 text-xs text-[#7A85A0]">
                      <span className="flex items-center gap-1">
                        <Phone className="h-3 w-3" /> {notif.patient_phone}
                      </span>
                      <span className="flex items-center gap-1">
                        <Clock className="h-3 w-3" /> {new Date(notif.created_at).toLocaleString('pt-BR')}
                      </span>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))
        )}
      </div>
    </div>
  );
};
